"use client";

import { Suspense } from "react";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { InteractiveMapProps } from "../../type";
import { truncate } from "lodash";


const containerStyle = {
  width: "100%",
  height: "450px",
};

const center = {
  lat: 6.4383,
  lng: 3.5087,
};

const locations = [
  {
    name: "Circle Mall",
    position: { lat: 6.4382876, lng: 3.5087113 },
  },
];

const InteractiveMap = ({ location }: InteractiveMapProps) => {
  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY!}>
      <div className="relative w-full h-[520px] rounded-[20px]">
        <Map
          defaultCenter={center}
          defaultZoom={15}
          style={containerStyle}
          gestureHandling="greedy"
          disableDefaultUI={true}
          mapId=""
        >
          {locations.map((loc, index) => (
            <Marker
              key={index}
              position={loc.position}
              title={loc.name}
              onClick={() => {
                const { lat, lng } = loc.position;
                const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
                window.open(mapsUrl, "_blank");
              }}
            />
          ))}
        </Map>

        <div className="absolute top-4 left-4 bg-white shadow-md rounded-md  text-sm text-gray-900 z-10 w-[90%] sm:w-auto">
          <div className="w-[350px] p-5 flex flex-col sm:flex-row  gap-2">
            <div>
              <img src="images/Location pin.svg" alt="marker" />
            </div>
            <div className="flex flex-col gap-1">
              <p className="font-worksans text-[#0E1728] text-lg sm:text-xl">
                {location.name}
              </p>
              <p className="text-base md:block hidden  text-[#464748] font-onest">
                {location.address}
              </p>
              <p className="text-base md:hidden block  text-[#464748] font-onest">
                {truncate(location.address)}
              </p>
              <a
                href={location.mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#289D17]  text-base font-onestMedium"
              >
                Open in Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </APIProvider>
  );
};

export default function MapWrapper({ location }: InteractiveMapProps) {
  return (
    <div className="w-full h-[450px]  relative">
      <Suspense fallback={<div className="w-full h-[450px] rounded-sm" />}>
        <InteractiveMap location={location} />
      </Suspense>
    </div>
  );
}
